import React, { useState } from "react";

import { GradientDefs } from "../../GradientDefs";

let maskUid = 0;

/**
 * @component GitRepositoryConnectIcon
 * @description
 * Outline repository glyph (a stacked database cylinder) with a cutout in the
 * upper-right corner holding a small plug badge — used to signify connecting /
 * linking a repository.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const GitRepositoryConnectIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => {
    const [maskId] = useState(() => `git-repository-connect-cut-${++maskUid}`);

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        data-testid="GitRepositoryConnectIcon"
        fill="none"
        stroke={
          gradient
            ? "url(#icon-gradient)"
            : props?.stroke
            ? props.stroke
            : "var(--color-theme-600)"
        }
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable={false}
        ref={ref}
        {...props}
      >
        <GradientDefs gradient={gradient} />
        <defs>
          <mask id={maskId}>
            <rect
              x={0}
              y={0}
              width={24}
              height={24}
              fill="#fff"
              stroke="none"
            />
            <circle cx={18.8} cy={4.6} r={5.5} fill="#000" stroke="none" />
          </mask>
        </defs>
        <g mask={`url(#${maskId})`}>
          <path d="M12 4m-8 0a8 2 0 1 0 16 0a8 2 0 1 0 -16 0" />
          <path d="M4 4v5a8 2 0 0 0 16 0v-5" />
          <path d="M4 9v5a8 2 0 0 0 16 0v-5" />
          <path d="M4 14v5a8 2 0 0 0 16 0v-5" />
        </g>
        <g transform="rotate(45 18.8 4.6)">
          <path d="M17.6 1.9v1.4" />
          <path d="M20 1.9v1.4" />
          <path d="M16.7 3.3h4.2v1.5a2.1 2.1 0 0 1 -2.1 2.1a2.1 2.1 0 0 1 -2.1 -2.1z" />
          <path d="M18.8 6.9v1.6" />
        </g>
      </svg>
    );
  }
);
GitRepositoryConnectIcon.displayName = "GitRepositoryConnectIcon";
export default GitRepositoryConnectIcon;
